<template>
  <div class="c-top-tabbar">
    <!-- <img src="../../assets/logo.png" class="c-top-tabbar__logo" /> -->
    <div class="c-top-tabbar__logo"></div> 
    <div class="c-top-tabbar__list">
      <div
        class="c-top-tabbar__item"
        :class="{ 'item-active': index === tabListSelectIndex }"
        v-for="(tab, index) in tabList"
        :key="index"
        @click="toSelectTab(index)"
        v-show="![3, 4].includes(index)"
      >
        <div class="c-top-tabbar__tab">{{ tab }}</div>
        <div class="active-border"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TopTabbar",
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabListSelectIndex: -1,
    };
  },
  methods: {
    toSelectTab(i) {
      if (i === this.tabListSelectIndex) return;
      this.tabListSelectIndex = i;
      this.$emit("tabClick", this.tabListSelectIndex);
    },
  },
};
</script>
<style scoped>
.c-top-tabbar {
  width: 1920px;
  height: 140px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 80px;
  box-sizing: border-box;
}
.c-top-tabbar__logo {
  width: 217px;
  height: 60px;
  flex-shrink: 0;
  margin-top: 39px;
}
.c-top-tabbar__list {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 58px;
}
.c-top-tabbar__item {
  height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 80px;
  position: relative;
}
.c-top-tabbar__item:last-child {
  margin-right: 0;
}
.c-top-tabbar__tab {
  caret-color: transparent;
  cursor: pointer;

  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 22px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-top-tabbar__item.item-active .c-top-tabbar__tab {
  color: #0c112e;
  font-family: Source Han Sans CN;
  font-size: 22px;
  font-weight: 700;
  line-height: 22px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-top-tabbar__item.item-active .active-border {
  content: "";
  width: 40px;
  height: 6px;
  border-radius: 4px;
  background-color: #0c112e;
  position: absolute;
  bottom: 0;
}
</style>